import createAction from '../../services/create-action';
export var SET_APP_CONFIG = 'app-config/SET';
export var setAppConfig = createAction(SET_APP_CONFIG);
